import { getResumeOrSectionIndex } from '../../handlers';
import { handleExpertiseCheckbox, handleNewExpertiseCheckbox } from '../Expertise/utils';
import { handleSubmit } from '../../components/ProgressiveFormStepper/utils';

export const handleCheckBoxLabel = (props, e, qid, qValue, index) => {
  e.currentTarget.checked = e.currentTarget.checked ? false : true;
  handleCheckbox(props, e, qid, qValue, index);
}
export const handleCheckbox = (props, e, qid, qValue, index) => {
  if (props.stateProps.sectionData.sectionName === 'technical-skills') {
    handleExpertiseCheckbox(props, e, qid, qValue, index);
  } else {
    const isChecked = e.currentTarget.checked;
    const secPart = props.formikProps.values.jobSeekerData[index];
    secPart[qid] = typeof secPart[qid] !== 'undefined' ? secPart[qid] : [];
    if (isChecked) {
      props.formikProps.values.jobSeekerData[index][qid].push(qValue);
    } else {
      removeCheckedItem(props, index, qid, qValue);
    }
  }
  if (props.stateProps.sectionData.sectionName === 'computer-skills') {
    handleSubmit(props, 'computer-skills');
  }
  props.stateProps.setCounter(props.stateProps.counter + '1');
};
export const handleNewCheckbox = (props, qObj) => {
  if (props.stateProps.sectionData.sectionName === 'technical-skills') {
    handleNewExpertiseCheckbox(props, qObj);
  } else {
    const addButton = document.querySelector('#addAnother_' + qObj.qid);
    const value = addButton.value;
    let add = value.trim().length > 0 ? true : false;
    if (qObj.options) {
      for (let i = 0; i < qObj.options.length; i++) {
        if (qObj.options[i].key === value) {
          add = false;
          break;
        }
      }
    }
    if (add) {
      const newCheckBoxValue = { label: value, key: value, value: value };
      qObj.options.push(newCheckBoxValue);
      let index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
      if (index === -1) {
        index = 0;
      }
      if (!props.formikProps.values.jobSeekerData[index][qObj.qid]) {
        props.formikProps.values.jobSeekerData[index][qObj.qid] = [];
      }
      props.formikProps.values.jobSeekerData[index][qObj.qid].push(value);
      let counter = props.stateProps.counter;
      props.stateProps.setCounter(counter + 1);
    }
    addButton.value = '';
  }
};
export const setOptions = (props, qObj, index) => {
  const values = typeof props.formikProps.values.jobSeekerData[index][qObj.qid] !== 'undefined' ?
    props.formikProps.values.jobSeekerData[index][qObj.qid] : [];

  const newValues = [];
  for (const savedValue of values) {
    let newValue = null;
    for (const option of qObj.options) {
      if (savedValue === option.value) {
        newValue = null;
        break;
      } else {
        newValue = savedValue;
      }
    }
    if (newValue !== null) {
      newValues.push(newValue);
    }
  }
  for (const value of newValues) {
    qObj.options.push({ key: value, value: value, label: value });
  }
};
export const removeCheckedItem = (props, index, qid, qValue) => {
  if (index === -1) {
    index = 0;
  }
  const checkboxArray = props.formikProps.values.jobSeekerData[index][qid];
  for (const [i, item] of checkboxArray.entries()) {
    if (qValue === item) {
      checkboxArray.splice(i, 1);
    }
  }
};